var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCaution40 = function SvgLightIcnCaution40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFE56B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillRule: "evenodd",
    d: "M21.347 22.38c-.02.672-.6 1.008-1.18 1.008-.56 0-1.14-.336-1.16-1.008-.1-3.118-.2-6.235-.28-9.354 0-.69.68-1.026 1.46-1.026.76 0 1.48.335 1.48 1.026-.12 3.119-.2 6.236-.32 9.354m-1.18 2.82c.82 0 1.5.634 1.5 1.38 0 .785-.68 1.42-1.5 1.42-.84 0-1.5-.635-1.5-1.42 0-.746.66-1.38 1.5-1.38",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnCaution40;